export const TABLE_BLOCK = 'table'
export const TABLE_ROW_BLOCK = 'table-row'
export const TABLE_CELL_BLOCK = 'table-cell'
